export default "__VITE_ASSET__DSVgpx$9__"